import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };
  declare urlValue: string;

  connect(): void {
    window.location.href = this.urlValue;
  }
}
